import React from 'react';
import { useNavigate } from 'react-router-dom';

const Header = ({
  isAuthenticated,
  currentUser,
  handleLogout,
  setShowLoginForm,
  setShowRegisterForm,
  setView,
  view,
}) => {
  const navigate = useNavigate();

  return (
    <div className="w-full mb-6">
      {/* Compact top bar with user info and logout */}
      <div className="flex items-center justify-between py-2 px-6 bg-gradient-to-r from-blue-800 via-blue-700 to-purple-600 shadow-lg">
        {/* Left side - Compact Logo */}
        <div className="flex items-center space-x-3">
          <div className="text-white font-bold flex items-center space-x-2">
            <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
              <span className="text-lg">📚</span>
            </div>
            <span className="text-lg font-bold tracking-wide">English Learning</span>
          </div>
        </div>

        {/* Right side - Compact User info and logout */}
        <div className="flex items-center space-x-3">
          {isAuthenticated ? (
            <>
              <div className="flex items-center space-x-3 bg-white/15 backdrop-blur-sm rounded-lg px-3 py-1.5 border border-white/20">
                <div className="w-7 h-7 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center shadow-md">
                  <span className="text-white font-bold text-sm">
                    {currentUser?.username?.charAt(0)?.toUpperCase() || 'U'}
                  </span>
                </div>
                <span className="text-white font-semibold text-sm">
                  {currentUser?.username}
                </span>
              </div>
              
              {/* Reload Button */}
              <button
                onClick={() => window.location.reload()}
                className="flex items-center space-x-1.5 px-3 py-1.5 bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-semibold rounded-lg transition-all transform hover:scale-105 shadow-md text-sm"
                title="Tải lại trang"
              >
                <span>🔄</span>
                <span>Reload</span>
              </button>
              
              {/* Admin Button - chỉ hiển thị cho admin */}
              {currentUser?.role === 'admin' && (
                <button
                  onClick={() => navigate('/admin')}
                  className="flex items-center space-x-1.5 px-3 py-1.5 bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white font-semibold rounded-lg transition-all transform hover:scale-105 shadow-md text-sm"
                  title="Quản lý License"
                >
                  <span>🛡️</span>
                  <span>Admin</span>
                </button>
              )}
              
              <button
                onClick={handleLogout}
                className="flex items-center space-x-1.5 px-3 py-1.5 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-semibold rounded-lg transition-all transform hover:scale-105 shadow-md text-sm"
                title="Đăng xuất"
              >
                <span>🚪</span>
                <span>Đăng xuất</span>
              </button>
            </>
          ) : (
            <div className="flex items-center space-x-2">
              <button
                onClick={() => setShowLoginForm(true)}
                className="px-4 py-1.5 font-semibold rounded-lg transition-all bg-white/20 hover:bg-white/30 text-white border border-white/30 backdrop-blur-sm text-sm"
              >
                Đăng nhập
              </button>
              <button
                onClick={() => setShowRegisterForm(true)}
                className="px-4 py-1.5 font-semibold rounded-lg transition-all bg-white text-blue-700 hover:bg-gray-100 shadow-md text-sm"
              >
                Đăng ký
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Navigation buttons only - Full width */}
      <div className="bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-800 shadow-xl px-6 py-4">

        {/* Compact Navigation Buttons */}
        {isAuthenticated && (
          <div className="flex flex-wrap justify-center gap-3">
            {/* Lessons Button */}
            <button
              onClick={() => setView('lessons')}
              className={`group px-4 py-2 text-sm font-bold rounded-xl transition-all transform hover:scale-105 shadow-lg border border-white/20 ${
                view === 'lessons'
                  ? 'bg-gradient-to-r from-blue-600 to-cyan-700 text-white ring-2 ring-white/30'
                  : 'bg-gradient-to-r from-blue-500 to-cyan-600 hover:from-blue-600 hover:to-cyan-700 text-white'
              }`}
              title="Quản lý bài học"
            >
              <span className="flex items-center space-x-1.5">
                <span className="text-base group-hover:animate-bounce">📚</span>
                <span className="hidden sm:inline">Bài học</span>
              </span>
            </button>

            {/* Exercise Generator Button */}
            <button
              onClick={() => setView('exercise-generator')}
              className={`group px-4 py-2 text-sm font-bold rounded-xl transition-all transform hover:scale-105 shadow-lg border border-white/20 ${
                view === 'exercise-generator'
                  ? 'bg-gradient-to-r from-emerald-600 to-teal-700 text-white ring-2 ring-white/30'
                  : 'bg-gradient-to-r from-emerald-500 to-teal-600 hover:from-emerald-600 hover:to-teal-700 text-white'
              }`}
              title="Tạo bài tập"
            >
              <span className="flex items-center space-x-1.5">
                <span className="text-base group-hover:animate-bounce">📝</span>
                <span className="hidden sm:inline">Tạo bài tập</span>
              </span>
            </button>

            {/* Hangman Game Button */}
            <button
              onClick={() => setView('hangman')}
              className={`group px-4 py-2 text-sm font-bold rounded-xl transition-all transform hover:scale-105 shadow-lg border border-white/20 ${
                view === 'hangman'
                  ? 'bg-gradient-to-r from-orange-600 to-red-700 text-white ring-2 ring-white/30'
                  : 'bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white'
              }`}
              title="Chơi game Đoán Chữ"
            >
              <span className="flex items-center space-x-1.5">
                <span className="text-base group-hover:animate-bounce">🎮</span>
                <span className="hidden sm:inline">Đoán Chữ</span>
              </span>
            </button>

            {/* Word Scramble Game Button */}
            <button
              onClick={() => setView('word-scramble')}
              className={`group px-4 py-2 text-sm font-bold rounded-xl transition-all transform hover:scale-105 shadow-lg border border-white/20 ${
                view === 'word-scramble'
                  ? 'bg-gradient-to-r from-purple-600 to-pink-700 text-white ring-2 ring-white/30'
                  : 'bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white'
              }`}
              title="Chơi game Sắp xếp chữ"
            >
              <span className="flex items-center space-x-1.5">
                <span className="text-base group-hover:animate-bounce">🔀</span>
                <span className="hidden sm:inline">Sắp xếp Chữ</span>
              </span>
            </button>

            {/* Drag & Drop Game Button */}
            <button
              onClick={() => setView('drag-drop')}
              className={`group px-4 py-2 text-sm font-bold rounded-xl transition-all transform hover:scale-105 shadow-lg border border-white/20 ${
                view === 'drag-drop'
                  ? 'bg-gradient-to-r from-green-600 to-teal-700 text-white ring-2 ring-white/30'
                  : 'bg-gradient-to-r from-green-500 to-teal-600 hover:from-green-600 hover:to-teal-700 text-white'
              }`}
              title="Trò chơi kéo thả ghép đôi"
            >
              <span className="flex items-center space-x-1.5">
                <span className="text-base group-hover:animate-bounce">🎯</span>
                <span className="hidden sm:inline">Kéo thả</span>
              </span>
            </button>

            {/* Chatbot Button */}
            <button
              onClick={() => setView('chatbot')}
              className={`group px-4 py-2 text-sm font-bold rounded-xl transition-all transform hover:scale-105 shadow-lg border border-white/20 ${
                view === 'chatbot'
                  ? 'bg-gradient-to-r from-indigo-600 to-blue-700 text-white ring-2 ring-white/30'
                  : 'bg-gradient-to-r from-rose-500 to-pink-600 hover:from-rose-600 hover:to-pink-700 text-white'
              }`}
              title="Luyện giao tiếp với AI"
            >
              <span className="flex items-center space-x-1.5">
                <span className="text-base group-hover:animate-bounce">🤖</span>
                <span className="hidden sm:inline">Chatbot</span>
              </span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;